import {
FETCH_TICKET_FAILURE,
FETCH_TICKET_REQUEST,
FETCH_TICKET_SUCCESS
} from '../actions/DSadminAction';

const initialState = {
  loading: false,
  ds_admin_ticket: null,
  error: null
};


export const ds_admin_ticketReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TICKET_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_TICKET_SUCCESS:
        console.log("ds ",action.payload)
      return { ...state, loading: false, ds_admin_ticket: action.payload };

    case FETCH_TICKET_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};